import { Tooltip as MuiTooltip, TooltipProps } from "@material-ui/core";
import { ReactNode } from "react";
import { classNames } from "../classNames/classNames";

export function Tooltip(
    props: Omit<TooltipProps, "children"> & { children: ReactNode | string | number; underline?: boolean | "none" }
): JSX.Element {
    const { children, underline } = props;
    const _underline = underline === "none" ? false : typeof underline === "boolean" ? underline : true;

    return (
        <MuiTooltip {...props}>
            <span
                className={classNames("border-dashed border-gray-400 print:border-none", {
                    "border-b": _underline && props.title,
                })}
            >
                {children}
            </span>
        </MuiTooltip>
    );
}
